<!-- Header -->
<h3 mat-dialog-title>
  INVALID SELECTION
</h3>

<!-- Body -->
<mat-dialog-content translate>
  <div>
    The following students already have this program/service:
  </div>
  <div>
    <span id = "spnMessage" style="white-space:pre-wrap;">{{message}}</span>
  </div>
  <div>
    Either go back to select a different program/service or continue and delete the student to remove program/service.
  </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
  <!-- Left Buttons -->
  <div class="footerLeft">
    <tyl-button image="previous arrow.png" label="Back" (clickEvent)="back(1)"></tyl-button>
  </div>
 
  <!-- Right Buttons -->
  <div class="footerRight">
    <tyl-button image="next arrow.png" label="Continue" (clickEvent)="continue(2)"></tyl-button>
  </div>
</mat-dialog-actions>